import {defineStore} from "pinia";
import {Ref} from "vue";
import {IShift} from "@/features/shifts/shifts.types";
import {shiftService} from "@/features/shifts/shifts.service";
import {IProfile} from "@/features/auth/auth.types";
import {authService} from "@/features/auth/auth.service";

export const useAuthStore = defineStore("auth", () => {

    async function getProfile(
        loading: Ref
    ): Promise<IProfile> {
        try {
            loading.value = true
            const {data} = await authService.profileInfo()
            return data
        } finally {
            loading.value = false
        }
    }

    async function signOut() {}

    return {getProfile};
});
